import { useSearchParams } from "react-router-dom";
import classes from "./CheckPayment.module.css";

const CheckPayment = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  return (
    <div className={classes.container}>
      {status === "success" ? (
        <>
          <h2>o(*￣▽￣*)ブ</h2>
          <h2>پرداخت شما با موفقیت انجام شد</h2>
        </>
      ) : status === "fail" ? (
        <>
          <h2>Σ(っ °Д °;)っ</h2>
          <h2>پرداخت شما انجام نشده است</h2>
        </>
      ) : status === "something-wrong-in-payment" ? (
        <>
          <h2>╰（‵□′）╯</h2>
          <h2>پرداخت شما انجام نشده اما اطلاعات با موفقیت در دیتابیس ثبت شده است</h2>
        </>
      ) : status === "something-wrong-in-db" ? (
        <>
          <h2>╰（‵□′）╯</h2>
          <h2>پرداخت شما با موفقیت انجام شده اما اطلاعات در دیتابیس ثبت نشده است</h2>
        </>
      ) : status === "success-wallet-withdrawal" ? (
        <>
          <h2>o(*￣▽￣*)ブ</h2>
          <h2>کیف پول شما با موفقیت شارژ شد</h2>
        </>
      ) : status === "fail-wallet-withdrawal" ? (
        <>
          <h2>Σ(っ °Д °;)っ</h2>
          <h2>متاسفانه کیف پول شما شارژ نشد</h2>
        </>
      ) : status === "something-wrong-in-payment-wallet-withdrawal" ? (
        <>
          <h2>╰（‵□′）╯</h2>
          <h2>پرداخت شما برای کیف پول انجام نشده اما اطلاعات با موفقیت در دیتابیس ثبت شده است</h2>
        </>
      ) : status === "something-wrong-in-db-wallet-withdrawal" ? (
        <>
          <h2>╰（‵□′）╯</h2>
          <h2>پرداخت شما برای کیف پول با موفقیت انجام شده اما اطلاعات در دیتابیس ثبت نشده است</h2>
        </>
      ) : status === "conflict" ? (
        <>
          <h2>╰（‵□′）╯</h2>
          <h2>ه سفارش در وضعیت Payment نیست یا resNum رو پیدا نکنیم</h2>
        </>
      ) : (
        <>
          <h2>(˘･_･˘)</h2> <h2> خطا در دریافت اطلاعات پرداخت</h2>
        </>
      )}
    </div>
  );
};

export default CheckPayment;
